import { cookieUtils } from "./cookieUtils";
import { ENV } from "@/constant";

export const client = async (
    endpoint: string,
    { body, token, ...customConfig }: any = {},
) => {
    const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
    const headers: any = isFormData ? {} : { "Content-Type": "application/json" };

    // Get token from cookies
    const cookieToken = cookieUtils.getAuthToken();

    // Use token from parameter if provided, otherwise use cookie token
    const authToken = token || cookieToken;

    if (authToken) {
        headers.Authorization = `Bearer ${authToken}`;
    }

    const config: RequestInit = {
        method: body ? "POST" : "GET",
        ...customConfig,
        headers: {
            ...headers,
            ...(customConfig.headers || {}),
        },
    };

    if (body) {
        config.body = isFormData ? body : JSON.stringify(body);
    }

    // Build URL using ENV without hardcoded IPs
    const BASE_URL = ENV.VITE_BASE_URL;
    // Ensure we don't end up with double slashes
    const path = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
    const url = `${BASE_URL}${path}`;
    try {
        const res = await fetch(url, config);

        const contentType = res.headers.get("content-type");

        if (contentType && contentType.includes("application/pdf")) {
            return res; // return raw PDF response
        }

        // Handle unauthorized responses
        if (res.status === 401) {
            cookieUtils.clearAllAuthCookies();
        }

        const data = await res.json();

        if (!res.ok) {
            throw { ...data, statusCode: res.status };
        }

        return { ...data, statusCode: res.status };
    } catch (err) {
        console.error("API client error:", err);
        return Promise.reject(err);
    }
};

export const getRandomString = () => {
    return Math.floor(Math.random() * Date.now()).toString(36);
};